/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Contest } from './Contest';
import {
    ContestFromJSON,
    ContestFromJSONTyped,
    ContestToJSON,
} from './Contest';

/**
 * 
 * @export
 * @interface PaginatedContestList
 */
export interface PaginatedContestList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedContestList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedContestList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedContestList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Contest>}
     * @memberof PaginatedContestList
     */
    results: Array<Contest>;
}

/**
 * Check if a given object implements the PaginatedContestList interface.
 */
export function instanceOfPaginatedContestList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;
    isInstance = isInstance && "results" in value;

    return isInstance;
}

export function PaginatedContestListFromJSON(json: any): PaginatedContestList {
    return PaginatedContestListFromJSONTyped(json, false);
}

export function PaginatedContestListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedContestList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ContestFromJSON)),
    };
}

export function PaginatedContestListToJSON(value?: PaginatedContestList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ContestToJSON)),
    };
}

